<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <!-- <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <v-icon
                color="#871B12"
                size="30"
                @click="getData()"
                >mdi-calendar-search</v-icon
              >
              <v-icon
                color="#871B12"
                size="30"
                @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row> -->
        <v-row>
          <v-row>
            <v-col cols="3">
              <v-btn
                :loading="!dataReady"
                :disabled="!dataReady"
                color="blue-grey"
                class="ma-2 white--text"
                @click="exportShiftTransfer()"
              >
                Download
                <v-icon right dark> mdi-cloud-download </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn
                :loading="!dataReady"
                :disabled="!dataReady"
                color="blue-grey"
                class="ma-2 white--text"
                @click="getData()"
              >
                reload
                <v-icon right dark> mdi-reload </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="searchAll"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- data table -->

          <v-col cols="12">
            <v-alert dense type="info" icon="mdi-account-switch">
              รายการ <strong>สลับกะการทำงาน</strong>
            </v-alert>
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-data-table
                  :headers="columnsFriend"
                  :items="dataItemFriend"
                  :search="searchAll"
                  :items-per-page="10"
                >
                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                  <template
                    v-slot:[`item.shiftTransferFriendAppoveStatus`]="{ item }"
                  >
                    <v-chip
                      class="ma-2"
                      color="secondary"
                      text-color="white"
                      v-if="item.shiftTransferFriendAppoveStatus === 'waiting'"
                    >
                      <v-icon left> mdi-account-clock </v-icon>
                      รอยืนยัน
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="red"
                      text-color="white"
                      v-if="item.shiftTransferFriendAppoveStatus === 'cancel'"
                    >
                      <v-icon left> mdi-account-remove </v-icon>
                      ยกเลิก
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="green"
                      text-color="white"
                      v-if="item.shiftTransferFriendAppoveStatus === 'approve'"
                    >
                      <v-icon> mdi-account-check-outline </v-icon>
                      ยืนยัน
                    </v-chip>
                  </template>
                  <template
                    v-slot:[`item.shiftTransferAppoveStatus`]="{ item }"
                  >
                    <v-chip
                      class="ma-2"
                      color="secondary"
                      text-color="white"
                      v-if="
                        item.shiftTransferAppoveStatus === 'waiting' &&
                        item.shiftTransferFriendAppoveStatus !== 'cancel'
                      "
                    >
                      <v-icon left> mdi-account-clock </v-icon>
                      รอดำเนินการ
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="success"
                      v-if="item.shiftTransferAppoveStatus === 'approve'"
                    >
                      <v-icon> mdi-account-check-outline </v-icon>
                      อนุมัติ
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="red"
                      text-color="white"
                      v-if="item.shiftTransferAppoveStatus === 'unapprove'"
                    >
                      <v-icon left> mdi-account-remove </v-icon>
                      ไม่อนุมัติ
                    </v-chip>
                  </template>
                  <template v-slot:[`item.action_approve_friend`]="{ item }">
                    <v-btn
                      color="info"
                      @click="(employeeInfo = []), getInfo(item)"
                    >
                      ตรวจสอบ
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>

          <v-col cols="12">
            <v-alert dense type="info" icon="mdi-account-convert">
              รายการอนุมัติสลับ <strong>วันทำงาน</strong>
            </v-alert>
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-data-table
                  :headers="columnsSelf"
                  :items="dataItemSelf"
                  :search="searchAll"
                  :items-per-page="10"
                >
                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                  <template
                    v-slot:[`item.shiftTransferAppoveStatus`]="{ item }"
                  >
                    <v-chip
                      class="ma-2"
                      color="secondary"
                      text-color="white"
                      v-if="item.shiftTransferAppoveStatus === 'waiting'"
                    >
                      <v-icon left> mdi-account-clock </v-icon>
                      รอดำเนินการ
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="success"
                      v-if="item.shiftTransferAppoveStatus === 'approve'"
                    >
                      <v-icon> mdi-account-check-outline </v-icon>
                      อนุมัติ
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="red"
                      text-color="white"
                      v-if="item.shiftTransferAppoveStatus === 'unapprove'"
                    >
                      <v-icon left> mdi-account-remove </v-icon>
                      ไม่อนุมัติ
                    </v-chip>
                  </template>
                  <template v-slot:[`item.action_approve_self`]="{ item }">
                    <v-btn
                      color="info"
                      @click="(employeeInfo = []), getInfoSelf(item)"
                    >
                      ตรวจสอบ
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>

          <v-col cols="12">
            <v-alert dense type="info" icon="mdi-account-convert">
              รายการอนุมัติ <strong>เปลี่ยนกะ</strong>
            </v-alert>
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-data-table
                  :headers="columnsSelf"
                  :items="dataItemShift"
                  :search="searchAll"
                  :items-per-page="10"
                >
                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                  <template
                    v-slot:[`item.shiftTransferAppoveStatus`]="{ item }"
                  >
                    <v-chip
                      class="ma-2"
                      color="secondary"
                      text-color="white"
                      v-if="item.shiftTransferAppoveStatus === 'waiting'"
                    >
                      <v-icon left> mdi-account-clock </v-icon>
                      รอดำเนินการ
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="success"
                      v-if="item.shiftTransferAppoveStatus === 'approve'"
                    >
                      <v-icon> mdi-account-check-outline </v-icon>
                      อนุมัติ
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="red"
                      text-color="white"
                      v-if="item.shiftTransferAppoveStatus === 'unapprove'"
                    >
                      <v-icon left> mdi-account-remove </v-icon>
                      ไม่อนุมัติ
                    </v-chip>
                  </template>
                  <template v-slot:[`item.action_approve_self`]="{ item }">
                    <v-btn
                      color="info"
                      @click="(employeeInfo = []), getInfoShift(item)"
                    >
                      ตรวจสอบ
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>

          <!-- ประวัติยกเลิก -->
          <v-col cols="12">
            <v-alert dense type="success" icon="mdi-account-check">
              รายการ <strong>ประวัติอนุมัติ</strong>
            </v-alert>
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-data-table
                  :headers="columnsFriend"
                  :items="dataItemApprove"
                  :search="searchAll"
                  :items-per-page="10"
                >
                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                  <template
                    v-slot:[`item.shiftTransferFriendAppoveStatus`]="{ item }"
                  >
                    <v-chip
                      class="ma-2"
                      color="secondary"
                      text-color="white"
                      v-if="item.shiftTransferFriendAppoveStatus === 'waiting'"
                    >
                      <v-icon left> mdi-account-clock </v-icon>
                      รอยืนยัน
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="red"
                      text-color="white"
                      v-if="item.shiftTransferFriendAppoveStatus === 'cancel'"
                    >
                      <v-icon left> mdi-account-remove </v-icon>
                      ยกเลิก
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="green"
                      text-color="white"
                      v-if="item.shiftTransferFriendAppoveStatus === 'approve'"
                    >
                      <v-icon> mdi-account-check-outline </v-icon>
                      ยืนยัน
                    </v-chip>
                  </template>
                  <template
                    v-slot:[`item.shiftTransferAppoveStatus`]="{ item }"
                  >
                    <v-chip
                      class="ma-2"
                      color="secondary"
                      text-color="white"
                      v-if="
                        item.shiftTransferAppoveStatus === 'waiting' &&
                        item.shiftTransferFriendAppoveStatus !== 'cancel'
                      "
                    >
                      <v-icon left> mdi-account-clock </v-icon>
                      รอดำเนินการ
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="success"
                      v-if="item.shiftTransferAppoveStatus === 'approve'"
                    >
                      <v-icon> mdi-account-check-outline </v-icon>
                      อนุมัติ
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="red"
                      text-color="white"
                      v-if="item.shiftTransferAppoveStatus === 'unapprove'"
                    >
                      <v-icon left> mdi-account-remove </v-icon>
                      ไม่อนุมัติ
                    </v-chip>
                  </template>
                  <template v-slot:[`item.action_approve_friend`]="{ item }">
                    <v-btn
                      color="info"
                      @click="(employeeInfo = []), getInfoDetail(item)"
                    >
                      ตรวจสอบ
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
          <!-- ประวัติยกเลิก -->
          <v-col cols="12">
            <v-alert dense type="error" icon="mdi-account-off">
              รายการ <strong>ประวัติยกเลิก</strong>
            </v-alert>
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-data-table
                  :headers="columnsFriend"
                  :items="dataItemCancelUnapprove"
                  :search="searchAll"
                  :items-per-page="10"
                >
                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                  <template
                    v-slot:[`item.shiftTransferFriendAppoveStatus`]="{ item }"
                  >
                    <v-chip
                      class="ma-2"
                      color="secondary"
                      text-color="white"
                      v-if="item.shiftTransferFriendAppoveStatus === 'waiting'"
                    >
                      <v-icon left> mdi-account-clock </v-icon>
                      รอยืนยัน
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="red"
                      text-color="white"
                      v-if="item.shiftTransferFriendAppoveStatus === 'cancel'"
                    >
                      <v-icon left> mdi-account-remove </v-icon>
                      ยกเลิก
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="green"
                      text-color="white"
                      v-if="item.shiftTransferFriendAppoveStatus === 'approve'"
                    >
                      <v-icon> mdi-account-check-outline </v-icon>
                      ยืนยัน
                    </v-chip>
                  </template>
                  <template
                    v-slot:[`item.shiftTransferAppoveStatus`]="{ item }"
                  >
                    <v-chip
                      class="ma-2"
                      color="secondary"
                      text-color="white"
                      v-if="
                        item.shiftTransferAppoveStatus === 'waiting' &&
                        item.shiftTransferFriendAppoveStatus !== 'cancel'
                      "
                    >
                      <v-icon left> mdi-account-clock </v-icon>
                      รอดำเนินการ
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="success"
                      v-if="item.shiftTransferAppoveStatus === 'approve'"
                    >
                      <v-icon> mdi-account-check-outline </v-icon>
                      อนุมัติ
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="red"
                      text-color="white"
                      v-if="item.shiftTransferAppoveStatus === 'unapprove'"
                    >
                      <v-icon left> mdi-account-remove </v-icon>
                      ไม่อนุมัติ
                    </v-chip>
                  </template>
                  <template v-slot:[`item.action_approve_friend`]="{ item }">
                    <v-btn
                      color="info"
                      @click="(employeeInfo = []), getInfoDetail(item)"
                    >
                      ตรวจสอบ
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
        <v-dialog v-model="dialogApproveFriend" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*กะของพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ employeeInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ employeeInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ employeeInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ employeeInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ employeeInfo.masCompanyName }}</td>
                          </tr>
                          <tr>
                            <td>กะพนักงานส่งคำร้อง</td>
                            <td>
                              <v-chip class="ma-2" color="yellow" label>
                                ({{ employeeInfo.shiftTransferOldShiftCode }})
                                {{ employeeInfo.OldDate }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*กะที่ต้องการสลับ</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ employeeInfo.empCodeFriend }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ employeeInfo.empFull_NameTH_Friend }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ employeeInfo.masDepartmentName_friend }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ employeeInfo.masBranchName_friend }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ employeeInfo.masCompanyName_friend }}</td>
                          </tr>
                          <tr>
                            <td>สลับกะการทำงาน</td>
                            <td>
                              <v-chip class="ma-2" color="primary" label>
                                ({{ employeeInfo.shiftTransferNewShiftCode }})
                                {{ employeeInfo.NewDate }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                :loading="!dataReady"
                :disabled="!dataReady"
                @click="dialogApproveFriend = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>
              <v-btn
                v-if="employeeInfo.shiftTransferAppoveStatus === 'waiting'"
                elevation="2"
                x-large
                class="ma-2"
                color="red"
                :loading="!dataReady"
                :disabled="!dataReady"
                @click="unapproveFriend(employeeInfo), dialogApproveFriend = false"
              >
                <v-icon left> mdi-account-remove</v-icon>
                ไม่อนุมัติ
                <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn>
              <v-btn
                v-if="employeeInfo.shiftTransferAppoveStatus === 'waiting'"
                elevation="2"
                x-large
                class="ma-2"
                color="success"
                :loading="!dataReady"
                :disabled="!dataReady"
                @click="approveFriend(employeeInfo), dialogApproveFriend = false"
              >
                <v-icon left> mdi-account-switch</v-icon>
                อนุมัติ
                <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- สลับวันหยุด -->
        <v-dialog v-model="dialogApproveSelf" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*กะของพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ employeeInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ employeeInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ employeeInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ employeeInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ employeeInfo.masCompanyName }}</td>
                          </tr>
                          <tr>
                            <td>กะพนักงานปัจจุบัน</td>
                            <td>
                              <v-chip class="ma-2" color="yellow" label>
                                ({{ employeeInfo.shiftTransferOldShiftCode }})
                                {{ employeeInfo.OldDate }}
                              </v-chip>
                            </td>
                          </tr>
                          <tr>
                            <td>สลับกะการทำงาน</td>
                            <td>
                              <v-chip class="ma-2" color="primary" label>
                                ({{ employeeInfo.shiftTransferNewShiftCode }})
                                {{ employeeInfo.NewDate }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                :loading="!dataReady"
                :disabled="!dataReady"
                @click="dialogApproveSelf = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>
              <v-btn
                v-if="employeeInfo.shiftTransferAppoveStatus === 'waiting'"
                elevation="2"
                x-large
                class="ma-2"
                color="red"
                :loading="!dataReady"
                :disabled="!dataReady"
                @click="unapproveSelf(employeeInfo), dialogApproveSelf = false"
              >
                <v-icon left> mdi-account-remove</v-icon>
                ไม่อนุมัติ
                <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn>
              <v-btn
                v-if="employeeInfo.shiftTransferAppoveStatus === 'waiting'"
                elevation="2"
                x-large
                class="ma-2"
                color="success"
                :loading="!dataReady"
                :disabled="!dataReady"
                @click="approveSelf(employeeInfo), dialogApproveSelf = false"
              >
                <v-icon left> mdi-account-switch</v-icon>
                ยืนยันสลับกะ
                <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- เปลี่ยนกะ -->
        <v-dialog v-model="dialogApproveShift" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*กะของพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ employeeInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ employeeInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ employeeInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ employeeInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ employeeInfo.masCompanyName }}</td>
                          </tr>
                          <tr>
                            <td>กะพนักงานปัจจุบัน</td>
                            <td>
                              <v-chip class="ma-2" color="yellow" label>
                                ({{ employeeInfo.shiftTransferOldShiftCode }})
                                {{ employeeInfo.OldDate }}
                              </v-chip>
                            </td>
                          </tr>
                          <tr>
                            <td>สลับกะการทำงาน</td>
                            <td>
                              <v-chip class="ma-2" color="primary" label>
                                ({{ employeeInfo.shiftTransferNewShiftCode }})
                                {{ employeeInfo.NewDate }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                :loading="!dataReady"
                :disabled="!dataReady"
                @click="dialogApproveShift = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>

              <v-btn
                v-if="employeeInfo.shiftTransferAppoveStatus === 'waiting'"
                elevation="2"
                x-large
                class="ma-2"
                color="red"
                :loading="!dataReady"
                :disabled="!dataReady"
                @click="unapproveShift(employeeInfo), dialogApproveShift = false"
              >
                <v-icon left> mdi-account-remove</v-icon>
                ไม่อนุมัติ
                <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn>
              <v-btn
                v-if="employeeInfo.shiftTransferAppoveStatus === 'waiting'"
                elevation="2"
                x-large
                class="ma-2"
                color="success"
                :loading="!dataReady"
                :disabled="!dataReady"
                @click="approveShift(employeeInfo), dialogApproveShift = false"
              >
                <v-icon left> mdi-account-switch</v-icon>
                ยืนยันสลับกะ
                <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- รายละเอียด -->
        <v-dialog v-model="dialogDetail" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*กะของพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ employeeInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ employeeInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ employeeInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ employeeInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ employeeInfo.masCompanyName }}</td>
                          </tr>
                          <tr>
                            <td>กะพนักงานส่งคำร้อง</td>
                            <td>
                              <v-chip class="ma-2" color="yellow" label>
                                ({{ employeeInfo.shiftTransferOldShiftCode }})
                                {{ employeeInfo.OldDate }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*กะที่ต้องการสลับ</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ employeeInfo.empCodeFriend }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ employeeInfo.empFull_NameTH_Friend }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ employeeInfo.masDepartmentName_friend }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ employeeInfo.masBranchName_friend }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ employeeInfo.masCompanyName_friend }}</td>
                          </tr>
                          <tr>
                            <td>สลับกะการทำงาน</td>
                            <td>
                              <v-chip class="ma-2" color="primary" label>
                                ({{ employeeInfo.shiftTransferNewShiftCode }})
                                {{ employeeInfo.NewDate }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogDetail = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { gmapApi } from 'vue2-google-maps'
import moment from 'moment'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    gmapApi
  },
  // created () {
  //   setInterval(this.getNowGlobal, 1000)
  // },
  data () {
    return {
      path: '/shift_transfer/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายการสลับกะสาขา',
          disabled: false,
          href: '/Shift/manageShiftTransferBranch'
        }
      ],
      session: this.$session.getAll(),
      loading: false,
      loading2: false,
      dataReady: false,
      dialogApproveFriend: false,
      dialogApproveSelf: false,
      dialogApproveShift: false,
      dialogDetail: false,
      columnsFriend: [
        { text: 'รหัสสลับกะ', value: 'shiftTransferId' },
        { text: 'ประเภท', value: 'shiftTransferType' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'กะปัจุบัน', value: 'shiftTransferOldShiftCodeName' },
        { text: 'เพื่อน', value: 'empFull_NameTH_Friend' },
        { text: 'กะที่สลับ', value: 'shiftTransferNewShiftCodeName' },
        { text: 'หมายเหตุ', value: 'shiftTransferRemark' },
        { text: 'เพื่อนอนุมัติ', value: 'shiftTransferFriendAppoveStatus' },
        { text: 'หัวหน้าอนุมัติ', value: 'shiftTransferAppoveStatus' },
        { text: 'ทำรายการล่าสุด', value: 'lastUser' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        {
          text: 'ตรวจสอบ',
          value: 'action_approve_friend',
          sortable: false,
          align: 'center'
        }
      ],
      columnsSelf: [
        { text: 'รหัสสลับกะ', value: 'shiftTransferId' },
        { text: 'ประเภท', value: 'shiftTransferType' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'กะปัจุบัน', value: 'shiftTransferOldShiftCodeName' },
        { text: 'กะที่สลับ', value: 'shiftTransferNewShiftCodeName' },
        { text: 'หมายเหตุ', value: 'shiftTransferRemark' },
        { text: 'หัวหน้าอนุมัติ', value: 'shiftTransferAppoveStatus' },
        { text: 'ทำรายการล่าสุด', value: 'lastUser' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        {
          text: 'ตรวจสอบ',
          value: 'action_approve_self',
          sortable: false,
          align: 'center'
        }
      ],
      dataItemSelf: [],
      dataItemShift: [],
      dataItemFriend: [],
      dataItemCancelUnapprove: [],
      dataItemApprove: [],
      employeeInfo: [],
      empShift01: [],
      empShift02: [],
      year: '',
      month: '',
      day: ''
    }
  },
  async mounted () {
    await this.getGetToken()
    await this.getData()
  },
  methods: {
    async getData () {
      var masBranchName = this.$session.getAll().data.masBranchName
      await this.getDataFriend(masBranchName)
      await this.getDataSelf(masBranchName)
      await this.getDataShift(masBranchName)
      await this.getDataApprove(masBranchName)
      await this.getDataUnapproveOrCancel(masBranchName)
    },
    async getDataFriend (masBranchName) {
      this.dataItemFriend = []
      if (masBranchName) {
        await axios
          .get(
          // eslint-disable-next-line quotes
            this.DNS_IP +
            this.path +
            'get?shiftTransferType=friend&shiftTransferFriendAppoveStatus=approve&shiftTransferAppoveStatus=waiting&masBranchName=' +
            masBranchName,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            this.dataReady = true
            this.dataItemFriend = response.data
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
          // console.log(error)
            this.dataReady = true
          })
      }
    },
    async getDataSelf (masBranchName) {
      this.dataItemSelf = []
      if (masBranchName) {
        await axios
          .get(
          // eslint-disable-next-line quotes
            this.DNS_IP +
            this.path +
            'get?shiftTransferType=self&shiftTransferAppoveStatus=waiting&masBranchName=' +
            masBranchName,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            this.dataReady = true
            this.dataItemSelf = response.data
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
          // console.log(error)
            this.dataReady = true
          })
      }
    },
    async getDataShift (masBranchName) {
      this.dataItemShift = []
      if (masBranchName) {
        await axios
          .get(
          // eslint-disable-next-line quotes
            this.DNS_IP +
            this.path +
            'get?shiftTransferType=shift&shiftTransferAppoveStatus=waiting&masBranchName=' +
            masBranchName,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            this.dataReady = true
            this.dataItemShift = response.data
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
          // console.log(error)
            this.dataReady = true
          })
      }
    },
    async getDataUnapproveOrCancel (masBranchName) {
      this.dataItemCancelUnapprove = []
      if (masBranchName) {
        await axios
          .get(
          // eslint-disable-next-line quotes
            this.DNS_IP +
            this.path +
            'getCancel?masBranchName=' + masBranchName,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            this.dataReady = true
            this.dataItemCancelUnapprove = response.data
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
          // console.log(error)
            this.dataReady = true
          })
      }
    },
    async getDataApprove (masBranchName) {
      this.dataItemApprove = []
      if (masBranchName) {
        await axios
          .get(
          // eslint-disable-next-line quotes
            this.DNS_IP +
            this.path +
            'getApprove?masBranchName=' + masBranchName,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            this.dataReady = true
            this.dataItemApprove = response.data
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
          // console.log(error)
            this.dataReady = true
          })
      }
    },
    async getInfo (item) {
      // this.employeeInfo = []
      this.dialogApproveFriend = true
      this.employeeInfo = item
      // await this.getCheckIn(item)
    },
    async getInfoSelf (item) {
      // this.employeeInfo = []
      this.dialogApproveSelf = true
      this.employeeInfo = item
      // console.log(item)
      // await this.getCheckIn(item)
    },
    async getInfoShift (item) {
      // this.employeeInfo = []
      this.dialogApproveShift = true
      this.employeeInfo = item
      // console.log(item)
      // await this.getCheckIn(item)
    },
    async getInfoDetail (item) {
      // await this.employeeInfo = []
      this.dialogDetail = true
      this.employeeInfo = item
      // console.log(item)
    },
    async approveFriend (item) {
      let ds1 = {
        empCode: item.empCode,
        shiftDay: item.shiftTransferOldDay,
        shiftMonth: item.shiftTransferOldMonth,
        shiftYear: item.shiftTransferOldYear,
        shiftCode: item.shiftTransferNewShiftCode
      }

      let ds2 = {
        empCode: item.empCodeFriend,
        shiftDay: item.shiftTransferNewDay,
        shiftMonth: item.shiftTransferNewMonth,
        shiftYear: item.shiftTransferNewYear,
        shiftCode: item.shiftTransferOldShiftCode
      }
      // this.dataReady = false
      // console.log(ds1)
      // console.log(ds2)
      // await this.setUpBeforeSendLine(item, 'อนุมัติสลับกะ', 'อนุมัติ', '017305')
      // await this.setUpBeforeSendLineFriend(item, 'อนุมัติสลับกะ', 'อนุมัติ', '017305')

      this.$swal({
        title: 'ต้องการ สลับกะ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#07ab0a',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          console.log(result)
          await this.updateShiftTransfer(ds1)
          await this.updateShiftTransfer(ds2)
          await this.getCheckIn(ds1, ds2)
          await this.updateStatus(item)
          await this.setUpBeforeSendLine(item, 'สลับกะ', 'อนุมัติ', '017305', 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20695.png?alt=media')
          await this.setUpBeforeSendLineFriend(item, 'อนุมัติสลับกะ', 'อนุมัติ', '017305', 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20695.png?alt=media')
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error : ', error)
        })
    },
    async approveSelf (item) {
      // console.log(item)
      let ds1 = {
        empCode: item.empCode,
        shiftDay: item.shiftTransferOldDay,
        shiftMonth: item.shiftTransferNewMonth,
        shiftYear: item.shiftTransferNewYear,
        shiftCode: item.shiftTransferNewShiftCode
      }
      // console.log(ds1)
      let ds2 = {
        empCode: item.empCode,
        shiftDay: item.shiftTransferNewDay,
        shiftMonth: item.shiftTransferOldMonth,
        shiftYear: item.shiftTransferOldYear,
        shiftCode: item.shiftTransferOldShiftCode
      }

      this.$swal({
        title: 'ต้องการ อนุมัติ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#07ab0a',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await this.updateShiftTransfer(ds1)
          await this.updateShiftTransfer(ds2)
          await this.getCheckIn(ds1, ds2)
          await this.updateStatus(item)
          await this.setUpBeforeSendLine(item, 'สลับวันหยุด', 'อนุมัติ', '017305', 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20695.png?alt=media')
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error : ', error)
        })
    },
    async approveShift (item) {
      // console.log(item)
      let ds1 = {
        empCode: item.empCode,
        shiftDay: item.shiftTransferOldDay,
        shiftMonth: item.shiftTransferNewMonth,
        shiftYear: item.shiftTransferNewYear,
        shiftCode: item.shiftTransferNewShiftCode
      }
      // console.log(ds1)
      let ds2 = {
        empCode: item.empCode,
        shiftDay: item.shiftTransferNewDay,
        shiftMonth: item.shiftTransferOldMonth,
        shiftYear: item.shiftTransferOldYear,
        shiftCode: item.shiftTransferOldShiftCode
      }

      this.$swal({
        title: 'ต้องการ อนุมัติ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#07ab0a',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await this.updateShiftTransfer(ds2)
          await this.updateShiftTransfer(ds1)
          await this.getCheckIn(ds1, ds2)
          await this.updateStatus(item)
          await this.setUpBeforeSendLine(item, 'เปลี่ยนกะ', 'อนุมัติ', '017305', 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20695.png?alt=media')
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error : ', error)
        })
    },
    async updateShiftTransfer (ds) {
      console.log(ds)
      console.log(this.DNS_IP + 'shift_transfer/updateShiftTransfer')
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/shift_transfer/updateShiftTransfer",
          ds,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log(response)
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getCheckIn (ds1, ds2) {
      this.empShift01 = []
      this.empShift02 = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?empCode=' +
            ds1.empCode +
            '&shiftMonth=' +
            ds1.shiftMonth +
            '&shiftYear=' +
            ds1.shiftYear +
            '&shiftDay=' +
            ds1.shiftDay
        )
        .then(async (response) => {
          this.empShift01 = response.data[0]
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log(error)
        })
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?empCode=' +
            ds2.empCode +
            '&shiftMonth=' +
            ds2.shiftMonth +
            '&shiftYear=' +
            ds2.shiftYear +
            '&shiftDay=' +
            ds2.shiftDay
        )
        .then(async (response) => {
          this.empShift02 = response.data[0]
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log(error)
        })
      console.log('this.empShift01', this.empShift01)
      console.log('this.empShift02', this.empShift02)
      await this.transferShift(this.empShift02, ds2)
      await this.transferShift(this.empShift01, ds1)
    },
    async transferShift (item, ds) {
      let data = {
        empCode: ds.empCode,
        shiftDay: item.shiftDay,
        shiftMonth: item.shiftMonth,
        shiftYear: item.shiftYear,
        shiftData: moment(item.shiftYear + '-' + item.shiftMonth + '-' + item.shiftDay).format('YYYY-MM-DD'),
        shiftCode: item.shiftCode,
        masShiftTypeStartTime: item.masShiftTypeStartTime || null,
        masShiftTypeEndTime: item.masShiftTypeEndTime || null,
        checkInStartStamp: item.checkInStartStamp || null,
        checkInStartLat: item.checkInStartLat || null,
        checkInStartLong: item.checkInStartLong || null,
        checkInEndStamp: item.checkInEndStamp || null,
        checkInEndLat: item.checkInEndLat || null,
        checkInEndLong: item.checkInEndLong || null,
        checkInMapUrl: item.checkInMapUrl || null,
        checkOutMapUrl: item.checkOutMapUrl || null,
        location: item.location || null
      }
      console.log('data', ds.empCode, data)

      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/ch_checkin/updateTransfer",
          data
        )
        .then(async (response) => {
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async updateStatus (item) {
      let data = {
        LAST_USER: this.$session.getAll().data.userName,
        shiftTransferAppoveStatus: 'approve',
        shiftTransferFriendAppoveStatus: 'approve'
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/shift_transfer/edit/" + item.shiftTransferId,
          data,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          /// / console.log(response)
          await this.getData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          // console.log(error)
        })
    },
    async unapproveFriend (item) {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ ไม่อนุมัติ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let data = {
            LAST_USER: this.$session.getAll().data.userName,
            shiftTransferAppoveStatus: 'unapprove'
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/shift_transfer/edit/" + item.shiftTransferId,
              data,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              /// / console.log(response)
              await this.setUpBeforeSendLine(item, 'สลับกะ', 'ไม่อนุมัติ', '800305', 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20699.png?alt=media')
              await this.setUpBeforeSendLineFriend(item, 'ไม่อนุมัติสลับกะ', 'ไม่อนุมัติ', '800305', 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20699.png?alt=media')
              await this.getData()
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              // console.log(error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error : ', error)
        })
    },
    async unapproveSelf (item) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ไม่อนุมัติ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let data = {
            LAST_USER: this.$session.getAll().data.userName,
            shiftTransferAppoveStatus: 'unapprove',
            shiftTransferFriendAppoveStatus: 'unapprove'
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/shift_transfer/edit/" + item.shiftTransferId,
              data,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              /// / console.log(response)
              await this.setUpBeforeSendLine(item, 'สลับวันหยุด', 'ไม่อนุมัติ', '800305', 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20699.png?alt=media')
              await this.getData()
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              // console.log(error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error : ', error)
        })
    },
    async unapproveShift (item) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ไม่อนุมัติ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let data = {
            LAST_USER: this.$session.getAll().data.userName,
            shiftTransferAppoveStatus: 'unapprove',
            shiftTransferFriendAppoveStatus: 'unapprove'
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/shift_transfer/edit/" + item.shiftTransferId,
              data,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              /// / console.log(response)
              await this.setUpBeforeSendLine(item, 'เปลี่ยนกะทำงาน', 'ไม่อนุมัติ', '800305', 'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2Fshift_transfer%2FGroup%20699.png?alt=media')
              await this.getData()
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              // console.log(error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error : ', error)
        })
    },
    async setUpBeforeSendLine (item, headstatus, status, color, imageUrl) {
      var payload = [

        {
          'type': 'flex',
          'altText': headstatus,
          'contents': {
            'type': 'bubble',
            'size': 'giga',
            'body': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'image',
                  'url': imageUrl,
                  'size': '70%',
                  'gravity': 'center'
                }
              ],
              'paddingAll': '0px'
            },
            'footer': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'box',
                  'layout': 'vertical',
                  'contents': [
                    {
                      'type': 'text',
                      'text': 'คำขอ' + headstatus,
                      'wrap': true,
                      'align': 'center'
                    },
                    {
                      'type': 'text',
                      'text': status,
                      'wrap': true,
                      'align': 'center',
                      'size': '26px',
                      'color': '#' + color
                    }
                  ],
                  'margin': '10px'
                },
                {
                  'type': 'box',
                  'layout': 'vertical',
                  'contents': [
                    {
                      'type': 'text',
                      'text': 'กะใหม่ของท่าน',
                      'wrap': true,
                      'align': 'center'
                    },
                    {
                      'type': 'text',
                      'text': '(' + item.shiftTransferNewShiftCode + ')' + item.shiftTransferOldYear + '-' + item.shiftTransferOldMonth + '-' + item.shiftTransferOldDay,
                      'wrap': true,
                      'align': 'center',
                      'color': '#' + color
                    },
                    {
                      'type': 'text',
                      'text': '(' + item.shiftTransferOldShiftCode + ')' + item.shiftTransferNewYear + '-' + item.shiftTransferNewMonth + '-' + item.shiftTransferNewDay,
                      'wrap': true,
                      'align': 'center',
                      'color': '#' + color
                    }
                  ],
                  'margin': '10px'
                },
                {
                  'type': 'box',
                  'layout': 'vertical',
                  'contents': [
                    {
                      'type': 'text',
                      'text': 'ขอให้เป็นวันที่ดีของท่าน',
                      'wrap': true,
                      'align': 'center',
                      'style': 'italic'
                    }
                  ],
                  'margin': '12px'
                }
              ]
            }
          }
        }

      ]
      const msgPayload = {
        // to: 'U97a2b1814542579b9e5d7c1b891538ab',
        to: item.userLineuserId,
        messages: payload
      }
      // console.log(JSON.stringify(msgPayload))

      let dt = {
        payload: msgPayload
      }

      await this.sendLinePush(dt)
    },
    async setUpBeforeSendLineFriend (item, headstatus, status, color, imageUrl) {
      var payload = [

        {
          'type': 'flex',
          'altText': headstatus,
          'contents': {
            'type': 'bubble',
            'size': 'giga',
            'body': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'image',
                  'url': imageUrl,
                  'size': '70%',
                  'gravity': 'center'
                }
              ],
              'paddingAll': '0px'
            },
            'footer': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'box',
                  'layout': 'vertical',
                  'contents': [
                    {
                      'type': 'text',
                      'text': 'คำขออสลับกะทำงาน',
                      'wrap': true,
                      'align': 'center'
                    },
                    {
                      'type': 'text',
                      'text': status,
                      'wrap': true,
                      'align': 'center',
                      'size': '26px',
                      'color': '#' + color
                    }
                  ],
                  'margin': '10px'
                },
                {
                  'type': 'box',
                  'layout': 'vertical',
                  'contents': [
                    {
                      'type': 'text',
                      'text': item.shiftTransferNewShiftCodeName,
                      'wrap': true,
                      'align': 'center',
                      'color': '#' + color
                    },
                    {
                      'type': 'text',
                      'text': 'ได้รับคำขอสลับกะกับ',
                      'wrap': true,
                      'align': 'center'
                    },
                    {
                      'type': 'text',
                      'text': item.empFull_NameTH,
                      'wrap': true,
                      'align': 'center'
                    },
                    {
                      'type': 'text',
                      'text': item.shiftTransferOldShiftCodeName,
                      'wrap': true,
                      'align': 'center',
                      'color': '#' + color
                    }

                  ],
                  'margin': '10px'
                }
              ]
            }
          }
        }

      ]
      const msgPayload = {
        // to: 'U97a2b1814542579b9e5d7c1b891538ab',
        to: item.userLineuserIdFriend,
        messages: payload
      }
      // console.log(JSON.stringify(msgPayload))

      let dt = {
        payload: msgPayload
      }
      await this.sendLinePush(dt)
    },
    async sendLinePush (dt) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/push_message",
          dt, {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          // console.log(response)
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log('linenotify: ', error)
        })
    },
    async exportShiftTransfer () {
      var dataFriend = []
      var dataSelf = []
      var dataShift = []
      var dataUnapprove = []
      var dataApprove = []
      this.dataItemFriend.forEach((element) => {
        let s = {
          รหัสสลับกะ: element.shiftTransferId,
          ประเภทขอสลับกะ: element.shiftTransferType,
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          สาขา: element.masBranchName,
          บริษัท: element.masCompanyName,
          แผนก: element.masDepartmentName,
          ชื่อผู้รับ: element.empFull_NameTH_Friend,
          สาขาผู้รับ: element.masBranchName_friend,
          บริษัทผู้รับ: element.masCompanyName_friend,
          แผนกผู้รับ: element.masDepartmentName_friend,
          ปีก่อนเปลี่ยน: element.shiftTransferOldYear,
          เดือนก่อนเปลี่ยน: element.shiftTransferOldMonth,
          วันทีก่อนเปลี่ยน: element.shiftTransferOldDay,
          olddate: element.OldDate,
          รหัสกะเก่า: element.shiftTransferOldShiftCode,
          ปีที่ขอเปลี่ยน: element.shiftTransferNewYear,
          เดือนที่ขอเปลี่ยน: element.shiftTransferNewMonth,
          วันที่ขอเปลี่ยน: element.shiftTransferNewDay,
          date: element.NewDate,
          กะใหม่: element.shiftTransferNewShiftCode,
          สถานะอนุมัติผู้รับ: element.shiftTransferFriendAppoveStatus,
          สถานะหัวหน้าอนุมัติ: element.shiftTransferAppoveStatus,
          วันที่สร้างข้อมูล: element.CREATE_DATE
        }
        dataFriend.push(s)
      })
      this.dataItemSelf.forEach((element) => {
        let s = {
          รหัสสลับกะ: element.shiftTransferId,
          ประเภทขอสลับกะ: element.shiftTransferType,
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          สาขา: element.masBranchName,
          บริษัท: element.masCompanyName,
          แผนก: element.masDepartmentName,
          ปีก่อนเปลี่ยน: element.shiftTransferOldYear,
          เดือนก่อนเปลี่ยน: element.shiftTransferOldMonth,
          วันทีก่อนเปลี่ยน: element.shiftTransferOldDay,
          olddate: element.OldDate,
          รหัสกะเก่า: element.shiftTransferOldShiftCode,
          ปีที่ขอเปลี่ยน: element.shiftTransferNewYear,
          เดือนที่ขอเปลี่ยน: element.shiftTransferNewMonth,
          วันที่ขอเปลี่ยน: element.shiftTransferNewDay,
          date: element.NewDate,
          กะใหม่: element.shiftTransferNewShiftCode,
          สถานะหัวหน้าอนุมัติ: element.shiftTransferAppoveStatus,
          วันที่สร้างข้อมูล: element.CREATE_DATE
        }
        dataSelf.push(s)
      })
      this.dataItemShift.forEach((element) => {
        let s = {
          รหัสสลับกะ: element.shiftTransferId,
          ประเภทขอสลับกะ: element.shiftTransferType,
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          สาขา: element.masBranchName,
          บริษัท: element.masCompanyName,
          แผนก: element.masDepartmentName,
          ปีก่อนเปลี่ยน: element.shiftTransferOldYear,
          เดือนก่อนเปลี่ยน: element.shiftTransferOldMonth,
          วันทีก่อนเปลี่ยน: element.shiftTransferOldDay,
          olddate: element.OldDate,
          รหัสกะเก่า: element.shiftTransferOldShiftCode,
          ปีที่ขอเปลี่ยน: element.shiftTransferNewYear,
          เดือนที่ขอเปลี่ยน: element.shiftTransferNewMonth,
          วันที่ขอเปลี่ยน: element.shiftTransferNewDay,
          date: element.NewDate,
          กะใหม่: element.shiftTransferNewShiftCode,
          สถานะหัวหน้าอนุมัติ: element.shiftTransferAppoveStatus,
          วันที่สร้างข้อมูล: element.CREATE_DATE
        }
        dataShift.push(s)
      })
      this.dataItemCancelUnapprove.forEach((element) => {
        let s = {
          รหัสสลับกะ: element.shiftTransferId,
          ประเภทขอสลับกะ: element.shiftTransferType,
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          สาขา: element.masBranchName,
          บริษัท: element.masCompanyName,
          แผนก: element.masDepartmentName,
          ชื่อผู้รับ: element.empFull_NameTH_Friend,
          สาขาผู้รับ: element.masBranchName_friend,
          บริษัทผู้รับ: element.masCompanyName_friend,
          แผนกผู้รับ: element.masDepartmentName_friend,
          ปีก่อนเปลี่ยน: element.shiftTransferOldYear,
          เดือนก่อนเปลี่ยน: element.shiftTransferOldMonth,
          วันทีก่อนเปลี่ยน: element.shiftTransferOldDay,
          olddate: element.OldDate,
          รหัสกะเก่า: element.shiftTransferOldShiftCode,
          ปีที่ขอเปลี่ยน: element.shiftTransferNewYear,
          เดือนที่ขอเปลี่ยน: element.shiftTransferNewMonth,
          วันที่ขอเปลี่ยน: element.shiftTransferNewDay,
          date: element.NewDate,
          กะใหม่: element.shiftTransferNewShiftCode,
          สถานะอนุมัติผู้รับ: element.shiftTransferFriendAppoveStatus,
          สถานะหัวหน้าอนุมัติ: element.shiftTransferAppoveStatus,
          วันที่สร้างข้อมูล: element.CREATE_DATE
        }
        dataUnapprove.push(s)
      })
      this.dataItemApprove.forEach((element) => {
        let s = {
          รหัสสลับกะ: element.shiftTransferId,
          ประเภทขอสลับกะ: element.shiftTransferType,
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          สาขา: element.masBranchName,
          บริษัท: element.masCompanyName,
          แผนก: element.masDepartmentName,
          ชื่อผู้รับ: element.empFull_NameTH_Friend,
          สาขาผู้รับ: element.masBranchName_friend,
          บริษัทผู้รับ: element.masCompanyName_friend,
          แผนกผู้รับ: element.masDepartmentName_friend,
          ปีก่อนเปลี่ยน: element.shiftTransferOldYear,
          เดือนก่อนเปลี่ยน: element.shiftTransferOldMonth,
          วันทีก่อนเปลี่ยน: element.shiftTransferOldDay,
          olddate: element.OldDate,
          รหัสกะเก่า: element.shiftTransferOldShiftCode,
          ปีที่ขอเปลี่ยน: element.shiftTransferNewYear,
          เดือนที่ขอเปลี่ยน: element.shiftTransferNewMonth,
          วันที่ขอเปลี่ยน: element.shiftTransferNewDay,
          date: element.NewDate,
          กะใหม่: element.shiftTransferNewShiftCode,
          สถานะอนุมัติผู้รับ: element.shiftTransferFriendAppoveStatus,
          สถานะหัวหน้าอนุมัติ: element.shiftTransferAppoveStatus,
          วันที่สร้างข้อมูล: element.CREATE_DATE
        }
        dataApprove.push(s)
      })

      var friend = XLSX.utils.json_to_sheet(dataFriend)
      var self = XLSX.utils.json_to_sheet(dataSelf)
      var shift = XLSX.utils.json_to_sheet(dataShift)
      var unapprove = XLSX.utils.json_to_sheet(dataUnapprove)
      var approve = XLSX.utils.json_to_sheet(dataApprove)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, friend, 'สลับกะการทำงาน') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, self, 'สลับวันหยุด') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, shift, 'เปลี่ยนกะ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, approve, 'รายการอนุมัติ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, unapprove, 'รายการไม่อนุมัติ') // sheetAName is name of Worksheet
      this.month = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      XLSX.writeFile(
        wb,
        'สลักกะทำงาน(' + this.day + ' ' + this.month + ' ' + this.year + ').xls'
      ) // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Shift/manageShiftTransferBranch.vue